import React, { FC } from 'react';
import { FamiliesListPage } from './family-list.page';
import { getLocalStorageDistrictId } from '../../../_core/utils';
import { useSessionStorage } from '../../../../hooks';
import { FamilyColumnName } from '../../hooks/table-columns/families-table-columns.hook';
import { AllowedFamilyActions } from '../../components/families-table/families-table-actions.component';

export const FamiliesListDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');

	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();
	const familyColumnsList: FamilyColumnName[] = [
		'fullName',
		'email',
		'phoneNumber',
		'location',
		'preferedLanguage',
		'totalEngagements',
		'actions',
	];
	const allowedFamilyActions: AllowedFamilyActions[] = ['view', 'delete', 'edit'];

	return <FamiliesListPage permission={{ create: true }} currentDistrictId={districtId} isAdminRoute={false} familyColumnsList={familyColumnsList} allowedFamilyActions={allowedFamilyActions}/>;
};
